import '../css/module_book.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';

import { initFirebaseApp } from './module_firebase';
import { manageLogin, openSignInModal } from './module_auth_helper';

import {
    sentryAPIErrorV2, 
    persUrl, 
    protectedApiCall,
    funnelUpdate,
    funnelUpdateWhenAvailable,
    setSkillXpLevelBar,
    uam,
    handleTryPremiumContentClick,
    attachTryPremiumSubscribe,
} from './module_common';

import { initTooltip } from './module_tooltip';

import { openModal } from './module_modal';

import {   
    getMatchesSkill,
    getSkillLevels,
    getLightSkill,
    getSkillsXp,
    sendBookLike,
    sendBookLikedFeedback,
    sendBookDislikedFeedback,
} from './module_api_call';

import {
    messageNotification,
    messageNotififyCloseAll,
} from './module_gamification_msg';

import {
    configPlayer, 
    pageSetup, 
    bookPostProgressAction,
    tocRowSelector,
    attachPlayerClick,
    attachFeedbackClick,
    closeMobileToc,
    setTocChapterPosition,
} from './module_player_new';

import {
    feedbackLikedModalSelector,
    feedbackDislikedModalSelector,
    initFeedback,
} from './module_feedback';

import {
    initReader,
    setReaderCurrentChapter,
    getStartChapter,
} from './module_cont_reader';

import {attachReadMoreClick} from './module_readmore';

import './module_common_actions';

import {
    attachCtaActions,
} from './module_actions';

import {
    getFavouriteElementId,
    getCurrentAction,
    addAction,
    removeAction,
    updateFavouriteUI,
    updateMobileFavouriteUI,
} from './module_toggle_favourite';

import { initNavbar } from './module_header';

// ----------------------------------------
// ** remember we also have book_visitor **
// ----------------------------------------

let skipProgress = false;
let startChapter = 0;
let xpPerBook = 50;
let skillLevels = [];
let updatedSkills = [];
let skills = [];

const favouriteSelector = '.add-to-favourite-attach-clk';

const downloadSelector = '.download-book';

let progressSent = false

const doRemoteUpdateReadProgress = function (chapter) {
    if (skipProgress) {
        skipProgress = false
        return
    }

    if (bPREP) {
        const ep = persUrl(bPREP);
        if (!ep) return;
        const data = {"book_id": bCode, "chapter": chapter};
        protectedApiCall('POST', ep,
            data,
            function (data) {
                checkAndShowBookFeedback(data)
                // use for first chapter
                progressSent=true
            },
            function (err) {
                const contextData = {
                    apicalldata:{
                        function: "doRemoteUpdateReadProgress",
                        url: ep,
                        method: 'POST',
                        data: JSON.stringify(data),
                        status: err.status,
                        response: err.responseJSON,
                        uid: UIDg,
                    }
                }
                const error = new Error('Error sending read progress for book')
                error.name = 'doRemoteUpdateReadProgress fail'
                sentryAPIErrorV2(error, contextData)
            },
            true);

    }
};

function datalayerBookRating(rating) {
    const isValid = rating === 'book_liked' || rating === 'book_disliked';
    if (isValid)
    dataLayer.push(
        {
            'event':'book_rating', 
            'book_rating':rating
        }
    );
}

const getXpLevel = function(xp){
    let idx = 0;
    for (const level of skillLevels) {
        const isInRange = xp >= level.min && xp <= level.max;
        const lastLevel = level.max == null;
        if (isInRange || lastLevel) break;
        idx ++;
    }
    const level = skillLevels[idx];
    return {
        name: level.translation.title,
        step: idx
    }
}

const addLevelToSkills = function(){
    skills.forEach(sk => {
        sk.level = getXpLevel(sk.xp)
    })
}

const addXpToSkill = function(sks, xps){
    const res = []
    for (const sk of sks){
        let xp = xps[sk.skill.id]
        if (typeof xp === 'undefined'){
            // send sentry?
            xp = 0
        }
        sk.xp= xp
        res.push(sk)
    }
    return res
}

const fillSkillElement = function(el, xp, name, level){
    const activeClass = getSkillCardActiveClass(xp)
    el.find(".name p").html(name)
    el.find(".xp p").html("+"+xpPerBook)
    let xpOrLevel = "+"+xpPerBook
    if (level !== ""){
        xpOrLevel = level
    }
    el.find(".xp p").html(xpOrLevel)
    el.find(".custom-badge span").html(xp+"xp")
    el.find(".xp-bar").data("xp", xp)
    el.find(".xp-point").removeClass("active")
    if (activeClass !== ""){
        el.find(activeClass).addClass("active")
    }
    
    return el
}

const getSkillCardActiveClass = function(xp){
    const xpLeve1 = 200
    const xpLeve2 = 400
    const xpLeve3 = 600
    let activeClass = ""
    if (xp > 0){
        activeClass = ".xp-point.point-0"
    }
    if (xp > xpLeve1){
        activeClass += ", .xp-point.point-1"
    }
    if (xp > xpLeve2){
        activeClass += ", .xp-point.point-2"
    }
    if (xp > xpLeve3){
        activeClass += ", .xp-point.point-3"
    }
    return activeClass
}

const fillModalTemplate = function(){
    const el = $('#' + XP_CONGRATS_WITH_SKILLS_MODAL)

    const cardTemplate = el.find(".skill-modal-card-wrap")
    let levelGrow = false
    for (const skill of updatedSkills){
        const cloned = cardTemplate.clone()
        let level = ""
        if (skill.levelGrow){
            levelGrow = true
            level = skill.level.name
        }
        const filled = fillSkillElement(cloned, skill.xp, skill.skill.translation.title, level)
        filled.appendTo(".game-xp-with-skill-box")    
    }
    cardTemplate.remove()
    if (levelGrow){
        el.find(".icon-cont.level-grow").removeClass("d-none")
        el.find(".icon-cont.level-unchanged").addClass("d-none")
    }
}

const messageNotifyClick = function(e){
    messageNotififyCloseAll()
    if (updatedSkills.length == 0){
        openModal('#' + XP_CONGRATS_MODAL, "messageNotifyClick")
    }else{
        fillModalTemplate()
        openModal('#' + XP_CONGRATS_WITH_SKILLS_MODAL, 'messageNotifyClick')
        setSkillXpLevelBar()
    }
}

const showXpToast = function (){
    let rowOne = ""
    let rowTwo = ""
    let skillTitle = ""
    const skills = updatedSkills
    if (skills.length >= 1){
        skillTitle = skills[0].skill.translation.title
    }
    switch (skills.length) {
        case 0:
            rowOne = "<span class='msg-bold'>"+gamificationMsgCongrats+"</span>"
            rowTwo = gamificationMsgEarned+" <span class='msg-colored'>"+xpPerBook+"xp</span>"
            break;
        case 1:
            rowOne = gamificationMsgEarned+" <span class='msg-colored'>"+xpPerBook+"xp</span>"
            rowTwo = gamificationMsgIn+" <span class='msg-bold'>"+skillTitle+"</span>"
            break;
        default:
            const plusNum = skills.length -1
            rowOne = gamificationMsgEarned+" <span class='msg-colored'>"+xpPerBook+"xp</span>"
            rowTwo = gamificationMsgIn+" <span class='msg-bold'>"+skillTitle+"</span> +"+plusNum
            break;
    }
    messageNotification(rowOne, rowTwo, messageNotifyClick)
}

const getSkillById = function(id){
    for (const sk of skills){
        if (sk.skill.id == id) return JSON.parse(JSON.stringify(sk))
    }
    return
}

const addXpAndOrderToSkill = function(matchedSkills){
    for (const sk of matchedSkills){
        const oldSkill = getSkillById(sk.skill.id)
        sk.xp += xpPerBook
        sk.level = getXpLevel(sk.xp)
        sk.levelGrow = false
        if (sk.level.name !== oldSkill.level.name) {sk.levelGrow = true}
    }
    matchedSkills.sort(function(a,b){
        return (a.levelGrow === b.levelGrow)? 0 : a.levelGrow ? -1 : 1
    })
    return matchedSkills
}

const manageSkillUpdateAndToast = function(){
    getMatchesSkill(bCode)
        .then(resp => {
            if (resp.matches && resp.matches.length > 0){
                const matchedSkills = []
                for (const match of resp.matches){
                    matchedSkills.push(getSkillById(match.skill_id))
                }
                updatedSkills = addXpAndOrderToSkill(matchedSkills)
            }
            showXpToast()
        })
        .catch(err => {
            const contextData = {
                functiondata:{
                    function: "manageSkillUpdateAndToast",
                    err: err,
                    uid: UIDg,
                    bid: bCode,
                }
            }
            const error = new Error('Error getting match skill for book')
            error.name = 'manageSkillUpdateAndToast fail'
            sentryAPIErrorV2(error, contextData)
            showXpToast()
        })
}

const checkAndShowBookFeedback = function (data) {
    // const source = data.progress.source
    if (data.progress.first_completed){
        if (data.xp_x_book) xpPerBook = data.xp_x_book
        manageSkillUpdateAndToast()
    }
}

const sendLike = function (bid, val) {
    let funnelEvent = "";
    if (val === 1) {
        funnelEvent = "book_liked"
    } else if (val === -1) {
        funnelEvent = "book_disliked"
    }

    return sendBookLike(bid, val)
        .then(() => {
            if (funnelEvent !== ""){
                funnelUpdate(funnelEvent);
                datalayerBookRating(funnelEvent);
            }
            switch (val) {
                case 1:
                    openModal(feedbackLikedModalSelector, 'sendLike')
                    break;
                case -1:
                    openModal(feedbackDislikedModalSelector, 'sendLike')
                    break;
                default:
                    break;
            }
            return val
        })
        .catch(() => {
            
        })
}

const onChapterChange = function (currentProgress) {
    const chapter = bookChapters[currentProgress];
    $(tocRowSelector).removeClass("current")
    const currentTocEl = $(tocRowSelector+'[data-chapterid="'+currentProgress+'"]')
    currentTocEl.addClass("current")
    
    setTocChapterPosition(currentProgress)

    //Update API progress read
    doRemoteUpdateReadProgress(chapter.number - 1)
    setReaderCurrentChapter(currentProgress+1)
}

const canRead = function(){
    if (UIDg &&  bookChapters.length !== 0) return true
    return false
}

// for user that can read book, intercept click on all player blocks
const onPlayerClickForCanRead = function(event){
    const target = $(event.target)
    const tocRow = target.parents(tocRowSelector)
    // click on TableOfContent row, go to chapter
    if (tocRow.length !== 0) {
        const el = $(tocRow[0])
        gotoChapter(el.data("chapterid"))   
    }
    // other elements are handled elsewhere
}

const onPlayerClickForCantRead = function(event){
    const target = $(event.target)
    // first chapter always free
    const firstRow = target.parents(tocRowSelector+"[data-chapterid=0]").length
    if (firstRow !== 0) return
    event.stopPropagation()
    if (!UIDg){
        openSignInModal()
    }else{
        handleTryPremiumContentClick(window.location.href)
    }
}

const gotoChapter = function (num, skipProg) {
    if (skipProg) skipProgress = true
    swiper.slideTo(num)
}

const disableChapterTocAccordion = function(){
    $('.heading-box[data-target="#table-of-content"]').click(function(e){
        e.stopPropagation()
    })
}

const loadUserSkills = function(){
    Promise.all([
        getSkillLevels(),
        getLightSkill(),
        getSkillsXp()
    ])
        .then(values => {
            skillLevels = values[0].levels
            skills = addXpToSkill(values[1].skills, values[2])
            addLevelToSkills()
        })
        .catch(err => {
            const contextData = {
                functiondata:{
                    function: "loadUserSkills",
                    err: err,
                    uid: UIDg,
                }
            }
            if (!err.status){
                contextData.functiondata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('Error loading user skill', {cause: err})
            error.name = 'loadUserSkills fail'
            sentryAPIErrorV2(error, contextData)
        })
}

const likeFeedbackPromise = function(bid, ids){
    return sendBookLikedFeedback(bid, ids)
}

const dislikeFeedbackPromise = function(bid, ids){
    return sendBookDislikedFeedback(bid, ids)
}

function updateBookFavourite(element) {
    const contId = getFavouriteElementId(element)
    const currentAction = getCurrentAction(element)

    const url = uam('/users/xxx/favourites/' + contId);
    
    let method = "POST";
    let newAction = 'remove';
    let funnelEvent = 'book_added_to_library';
    if (currentAction === removeAction) {
        method = "DELETE";
        newAction = addAction;
        funnelEvent = 'book_removed_from_library';
    }

    protectedApiCall(method, url, {},
        function () {
            funnelUpdate(funnelEvent);
            updateFavouriteUI(element, newAction)
            updateMobileFavouriteUI(element, newAction)
        }, function (err) {
            const contextData = {
                apicalldata:{
                    function: "updateBookFavourite",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error favourite for book')
            error.name = 'updateBookFavourite fail'
            sentryAPIErrorV2(error, contextData);
        }
    );
}

const attachUpdateFavourite = function(){
    $(favouriteSelector).click(function(e){
        if (!UIDg) {
            openSignInModal()
            return
        }
        const currentTarget = $(e.currentTarget)
        updateBookFavourite(currentTarget)
    })
}

const attachUpdateDownload = function(){
    $(downloadSelector).click(function(e){
        const currentTarget = $(e.currentTarget)
        if (currentTarget.hasClass('disabled')) return
        currentTarget.removeClass('active')
        currentTarget.addClass('selected')
    })
}

const doFirstChapterActions = function(){
    // landing on first chapter
    // send progress
    if (getStartChapter() == 0){
        manageEndOfChapterProgress(0)
    }
}

const manageEndOfChapterProgress = function(chapterProg){
    const target = document.getElementById("contentchapterend");
    function callback(entries, observer) {
        entries.forEach((entry) => {
            if(entry.isIntersecting) {
                if (progressSent) return
                doRemoteUpdateReadProgress(chapterProg)
            }
        });
    }
    function createObserver(target, callback) {
        const options = {
            root: null,
            threshold: 0
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(target);
    }
    
    createObserver(target, callback);
}

const attachCannotDownloadClick = function(){
    $(".cannot-download-attach-clk").click(function(){
        openModal("#cannotDownload", "attachCannotDownloadClick")
    })
}

const attachBookDownloadFunnelEvent = function(){
    $(".book-download-attach-clk").on('click', function(){
        funnelUpdate('book_downloaded_offline')
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initNavbar()

    initTooltip()

    // attachVisitorClick()
    attachCannotDownloadClick()
    attachBookDownloadFunnelEvent()
    
    const initReaderParams = {
        readerCurrentChapter: getStartChapter() + 1,
        onChapterChangeFunc: onChapterChange,
    }
    initReader(initReaderParams)
    doFirstChapterActions()
    setTocChapterPosition(getStartChapter())

    if (UIDg) loadUserSkills()
    
    attachCtaActions()

    attachUpdateFavourite()
    attachUpdateDownload()
    attachTryPremiumSubscribe()
    
    const canReadBook = canRead()
    // player
    configPlayer()
    pageSetup()
    attachPlayerClick(canReadBook, onPlayerClickForCanRead, onPlayerClickForCantRead)
    attachFeedbackClick(canReadBook, sendLike)
    closeMobileToc()

    // use this method to block accordion for chapters Table of content
    // disableChapterTocAccordion()
    
    attachReadMoreClick()
    
    bookPostProgressAction.do = function(data){
        // do something on audio progress
        checkAndShowBookFeedback(data)
    }

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('book_viewed')
    
    const feedbackParams = {
        sendContentLike: likeFeedbackPromise,
        sendContentDislike: dislikeFeedbackPromise,
    }
    initFeedback(feedbackParams)

    // url with chapter number, deprecated but still working
    if (isChapterPage){
        // player
        setTocChapterPosition(startChapter)
    }

});
